import logo from './logo.png';

import bin_icon from './bin_icon.png';
import dropdown_icon from './dropdown_icon.png';

export const assets = {
  dropdown_icon,

  bin_icon,
};
